import React, { useState, useMemo, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../../../../Shared/ManagerNavbar/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaEdit, FaEye, FaDownload, FaComment, FaTrash, FaCalendarAlt, FaSave, FaTimes, FaCopy, FaSpinner, FaRupeeSign } from "react-icons/fa";
import { Button,Row, Col, Form, Modal, Tab, Tabs } from "react-bootstrap";
import { HiUserGroup } from "react-icons/hi";
import DataTable from "../../../../Layout/Table/TableLayoutOpp";
import { baseURL } from "../../../../Apiservices/Api";
import './MyOppleads.css';
import axios from 'axios';
import { AuthContext } from '../../../../AuthContext/AuthContext';
import * as XLSX from 'xlsx';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { FontSizeContext } from "../../../../Shared/Font/FontContext";
import Loader from "../../../../Loader/Loader";
import { adminMail } from '../../../../Apiservices/Api';
import EmailCommentModalPop from "../../../Admin/Leads/ViewLeads/Comment/EmailCommentModalPop/EmailCommentModalPop";

const Potentialleads = () => { 
  
const queryClient = useQueryClient();
  const { fontSize } = useContext(FontSizeContext);
  const { authToken, userId, userName } = useContext(AuthContext);
  const [message, setMessage] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
const [showCommentsEmailModal, setShowCommentsEmailModal] = useState(false);
const [selectedLeadForModal, setSelectedLeadForModal] = useState(null);
const [userEmail, setUserEmail] = useState(null);;
  const [searchTerm, setSearchTerm] = useState(localStorage.getItem("searchTerm-m") || "");
  const [filterStatus, setFilterStatus] = useState(localStorage.getItem("filterStatus-m") || "");
  const [filterDestination, setFilterDestination] = useState(localStorage.getItem("filterDestination-m") || "");
  const [filterOppStatus1, setFilterOppStatus1] = useState(localStorage.getItem("filterOppStatus1-m") || "In Progress");
  const [filterOppStatus2, setFilterOppStatus2] = useState(localStorage.getItem("filterOppStatus2-m") || "");
   const [filterPrimarySource, setFilterPrimarySource] = useState(
      localStorage.getItem("filterPrimarySource-m") || ""
    );
    
    const [filterSecondarySource, setFilterSecondarySource] = useState(
      localStorage.getItem("filterSecondarySource-m") || ""
    );
  const [filterAssignee, setFilterAssignee] = useState(localStorage.getItem("filterAssignee-m") || "");
  const [filterStartDate, setFilterStartDate] = useState(localStorage.getItem("filterStartDate-m") || "");
  const [filterEndDate, setFilterEndDate] = useState(localStorage.getItem("filterEndDate-m") || "");
  const [appliedFilterStartDate, setAppliedFilterStartDate] = useState(localStorage.getItem("appliedFilterStartDate-m") || "");
  const [appliedFilterEndDate, setAppliedFilterEndDate] = useState(localStorage.getItem("appliedFilterEndDate-m") || "");

  // const [data, setData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);

  // Both start as true so spinner shows immediately, no empty state flash
  const [loadingLeads, setLoadingLeads] = useState(true);
  const [loadingEmployees, setLoadingEmployees] = useState(true);

  const primarySourceOptions = [
  "Referral",
  "Corporate",
  "Partner Promotion",
  "Media Coverage",
  "Blog",
  "Community",
  "Purchased Leads",
  "Social Media",
  "Google",
  "Meta",
  "Other",
];

  const sourceDropdownOptions = {
  Referral: ["Grade 3", "Grade 2", "Grade 1"],
  Corporate: ["BIW", "Others"],
  Community: ["BNI", "Rotary", "Lions", "Association", "Others"],
  "Purchased Leads": ["Tripcrafter", "Others"],
  "Social Media": ["Linkedin", "Others"],
  Google: [
    "Google Organic",
    "Google Ad",
    "Youtube Organic",
    "Youtube Paid",
  ],
  Meta: [ 
    "Facebook Organic",
    "Instagram Organic",
    "Facebook (Paid)",
    "Instagram (Paid)",
    "Others",
  ],
};

  const [showDateRange, setShowDateRange] = useState(
    localStorage.getItem("showDateRange-m") === "true"
  );

  useEffect(() => {
    localStorage.setItem("showDateRange-m", showDateRange);
  }, [showDateRange]);

  const {
  data = [],
  isLoading,
  isError,
  error,
} = useQuery({
  queryKey: ['my-manager-opportunity', userId],
  refetchInterval: 3000, // Refetch every 3 seconds to keep data updated
  queryFn: async () => {
    if (!userId) return [];

    const response = await axios.get(
      `${baseURL}/api/fetch-data-yesmanager`,
      { params: { userId } }
    );

    return response.data;
  },
  enabled: !!userId,
  keepPreviousData: true,
});


  // const fetchLeads = async () => {
  //   setLoadingLeads(true);
  //   try {
  //     const response = await axios.get(`${baseURL}/api/fetch-data-yesmanager`, {
  //       params: { userId }
  //     });
  //     setData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching leads:", error);
  //   } finally {
  //     setLoadingLeads(false);
  //   }
  // };

  const fetchEmployees = async () => {
    setLoadingEmployees(true);
    try {
      const response = await axios.get(`${baseURL}/employeesassign`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoadingEmployees(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  // Wait for userId before fetching
  useEffect(() => {
    if (!userId) return;
    // fetchLeads();
    fetchEmployees();
  }, [userId]);

  const [dropdownOptions, setDropdownOptions] = useState({
    primary: [],
    secondary: {}
  });
  
  useEffect(() => {
    fetchLeadStatus();
  }, []);
  
  const fetchLeadStatus = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/opp-status`);
      
      setDropdownOptions({
        primary: res.data.primary || [],
        secondary: res.data.secondary || {}
      });
  
    } catch (error) {
      console.error("Error fetching lead status:", error);
    }
  };


const updateOpportunityStatus = async (leadId, primaryStatus, secondaryStatus) => {
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['my-manager-opportunity', userId], (old = []) =>
    old.map((r) =>
      r.leadid === leadId
        ? {
            ...r,
            opportunity_status1: primaryStatus,
            opportunity_status2: secondaryStatus || '',
          }
        : r
    )
  );
 
  try {
    const response = await axios.put(`${baseURL}/api/update-status/${leadId}`, {
      opportunity_status1: primaryStatus,
      opportunity_status2: secondaryStatus || '',
    });
    if (response.status === 200) {
      setMessage('Status updated successfully.');
      setTimeout(() => setMessage(''), 1000);
      return true;
    }
  } catch {
    queryClient.invalidateQueries(['my-manager-opportunity', userId]); // ✅ rollback
    setMessage('Update failed, reverting...');
    setTimeout(() => setMessage(''), 1000);
  }
  return false;
};


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page"));
    if (!isNaN(pageFromUrl)) {
      setPageIndex(pageFromUrl - 1);
    }
  }, [location.search]);

  const handleEdit = (rowId, currentPage) => {
        const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';

    navigate(`/m-myedit-opportunity/${rowId}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: rowId } });
  };

const handleCommentClick = (lead) => {
  setSelectedLeadForModal(lead);
  setShowCommentsEmailModal(true);
};


// const handleEmailHistory = () => {
//   if (email) {
//     navigate(`/m_myemail-history/${selectedLeadForComment.leadid}`, { state: { email: email } });
//   }
// };


  const handleAssignLead = async (leadid, employeeId, status) => {
    const selectedEmp = employees.find((emp) => emp.id === parseInt(employeeId));
    const employeeName = selectedEmp ? selectedEmp.name : "";

    if (!employeeName) {
      setMessage("Please select a valid employee.");
      setTimeout(() => setMessage(""), 1000);
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/api/assign-lead`, {
        leadid,
        employeeId,
        employeeName,
        status,
        userId,
        userName,
      });

      if (response.status === 200) {
       queryClient.setQueryData(
  ['my-manager-opportunity', userId],
  (oldData = []) =>
    oldData.map((lead) =>
      lead.leadid === leadid
        ? {
            ...lead,
            assignedSalesName: employeeName,
            assignedSalesId: employeeId,
          }
        : lead
    )
);

        setMessage(response.data.message);
        setTimeout(() => setMessage(""), 1000);
      }
    } catch (error) {
      console.error("Error assigning lead:", error);
      setMessage("An error occurred while assigning the lead.");
      setTimeout(() => setMessage(""), 1000);
    }
  };

  const handleSelfAssign = async (leadid) => {
    try {
      const response = await axios.post(`${baseURL}/api/assign-manager`, {
        leadid,
        userId,
      });
      if (response.status === 200) {
        setMessage(response.data.message);
        setTimeout(() => setMessage(""), 1000);
       queryClient.setQueryData(
  ['my-manager-opportunity', userId],
  (oldData = []) =>
    oldData.map((lead) =>
      lead.leadid === leadid
        ? { ...lead, managerAssign: userId }
        : lead
    )
);

      } else {
        setMessage('Failed to assign the lead. Please try again.');
        setTimeout(() => setMessage(""), 1000);
      }
    } catch (error) {
      console.error("Error assigning lead:", error);
      setMessage('An error occurred while assigning the lead. Please try again.');
      setTimeout(() => setMessage(""), 1000);
    }
  };

  useEffect(() => {
    localStorage.setItem("searchTerm-m", searchTerm);
    localStorage.setItem("filterStatus-m", filterStatus);
    localStorage.setItem("filterDestination-m", filterDestination);
    localStorage.setItem("filterOppStatus1-m", filterOppStatus1);
    localStorage.setItem("filterOppStatus2-m", filterOppStatus2);
    localStorage.setItem("filterAssignee-m", filterAssignee);
    localStorage.setItem("filterStartDate-m", filterStartDate);
    localStorage.setItem("filterEndDate-m", filterEndDate);
            localStorage.setItem("filterPrimarySource-m", filterPrimarySource);
    localStorage.setItem("filterSecondarySource-m", filterSecondarySource);
    localStorage.setItem("appliedFilterStartDate-m", appliedFilterStartDate);
    localStorage.setItem("appliedFilterEndDate-m", appliedFilterEndDate);
  }, [
    searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2,
    filterAssignee, filterStartDate, filterEndDate, filterPrimarySource, filterSecondarySource,
    appliedFilterStartDate, appliedFilterEndDate
  ]);

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("");
    setFilterDestination("");
    setFilterOppStatus1("In Progress");
    setFilterOppStatus2("");
    setFilterAssignee("");
    setFilterPrimarySource("");
    setFilterSecondarySource("");
    setFilterStartDate("");
    setFilterEndDate("");
    setAppliedFilterStartDate("");
    setAppliedFilterEndDate("");
                                            setPageIndex(0);

                        const url = new URL(window.location);
                    url.searchParams.delete('page');
                                url.searchParams.set('pageSize', '20'); 
      url.searchParams.delete('pageSize');
                    window.history.pushState({}, '', url);


    localStorage.removeItem("potentialLeadsFilters-m");
  };

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const matchesFreeText = !searchTerm || Object.values(item).some(val =>
        val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
      const matchesStatus = !filterStatus || (item.status && item.status.toLowerCase() === filterStatus.toLowerCase());
      const matchesDestination = !filterDestination || (item.travel_destination && item.travel_destination.toLowerCase() === filterDestination.toLowerCase());
      const actualPrimaryStatus = item.opportunity_status1 ? item.opportunity_status1.toLowerCase() : "in progress";
      const matchesOppStatus1 = !filterOppStatus1 || actualPrimaryStatus === filterOppStatus1.toLowerCase();
      const matchesOppStatus2 = !filterOppStatus2 || (item.opportunity_status2 && item.opportunity_status2.toLowerCase() === filterOppStatus2.toLowerCase());
      const matchesAssignee = !filterAssignee || (item.assignedSalesName && item.assignedSalesName.toLowerCase() === filterAssignee.toLowerCase());
      const matchesPrimarySource =
  !filterPrimarySource ||
  (item.primarySource &&
    item.primarySource.toLowerCase() === filterPrimarySource.toLowerCase());

const matchesSecondarySource =
  !filterSecondarySource ||
  (item.secondarysource &&
    item.secondarysource.toLowerCase() === filterSecondarySource.toLowerCase());
      const matchesDateRange = (() => {
        if (appliedFilterStartDate && appliedFilterEndDate) {
          const start = new Date(appliedFilterStartDate);
          const end = new Date(appliedFilterEndDate);
          end.setHours(23, 59, 59, 999);
          const createdAt = new Date(item.travel_created_at);
          return createdAt >= start && createdAt <= end;
        }
        return true;
      })();
      return matchesFreeText && matchesStatus && matchesDestination && matchesOppStatus1 && matchesOppStatus2 && matchesAssignee && matchesDateRange && matchesPrimarySource && matchesSecondarySource;
    });
  }, [searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2, filterAssignee, appliedFilterStartDate, appliedFilterEndDate, filterPrimarySource, filterSecondarySource, data]);

  const columns = useMemo(() => [
    { Header: "OppId", accessor: "leadid" },
    {
      Header: "Name",
      accessor: "name",
                   Cell: ({ row }) => {
          const currentPage = pageIndex; 
              const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
          return (  
        <div
          style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
          onClick={() => navigate(`/m-mydetails/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}
        >
          {row.original.name}
        </div>
      )
    }
  },
    {
      Header: "Mobile",
      accessor: "phone_number",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href={`https://wa.me/${row.original.phone_number}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
            title="Chat on WhatsApp"
          >
            {row.original.phone_number}
          </a>
          <FaCopy
            style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
            onClick={() => copyToClipboard(row.original.phone_number)}
            title="Copy Phone Number"
          />
        </div>
      ),
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: "200px" }}>
          <div
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px" }}
            title={row.original.email}
          >
            {row.original.email}
          </div>
          <FaCopy
            style={{ cursor: "pointer", color: "#ff9966" }}
            onClick={() => copyToClipboard(row.original.email)}
            title="Copy Email"
          />
        </div>
      ),
    },
    {
      Header: "Destination",
      accessor: "travel_destination",
      Cell: ({ row }) => (
        <div
          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100px" }}
          title={row.original.travel_destination}
        >
          {row.original.travel_destination}
        </div>
      ),
    },
    {
      Header: "Opportunity Status",
      accessor: "opportunityStatus",
      Cell: ({ row }) => {
        const { fontSize } = useContext(FontSizeContext);
        const { opportunity_status1, opportunity_status2, leadid } = row.original;

        const [localPrimary, setLocalPrimary] = useState(opportunity_status1);
        const [localSecondary, setLocalSecondary] = useState(opportunity_status2);
        const [isDirty, setIsDirty] = useState(false);

        useEffect(() => {
          setLocalPrimary(opportunity_status1);
          setLocalSecondary(opportunity_status2);
          setIsDirty(false);
        }, [opportunity_status1, opportunity_status2]);

        const secondaryOptions = localPrimary ? (dropdownOptions.secondary[localPrimary] || []) : [];
        const isSecondaryDisabled = !localPrimary || secondaryOptions.length === 0;

        const handlePrimaryChange = (e) => {
          setLocalPrimary(e.target.value);
          setLocalSecondary("");
          setIsDirty(true);
        };

        const handleSecondaryChange = (e) => {
          setLocalSecondary(e.target.value);
          setIsDirty(true);
        };

        const canSave = localPrimary &&
          (secondaryOptions.length === 0 || (secondaryOptions.length > 0 && localSecondary));

        const handleSave = async () => {
          try {
            await updateOpportunityStatus(leadid, localPrimary, localSecondary);
           queryClient.setQueryData(
      ['my-manager-opportunity', userId],
      (oldData = []) =>
        oldData.map((r) =>
          r.leadid === leadid
            ? {
                ...r,
                opportunity_status1: localPrimary,
                opportunity_status2: localSecondary,
              }
            : r
        )
    );
            setIsDirty(false);
          } catch (error) {
            console.error('Error saving status:', error);
          }
        };

        return (
          <div className="d-flex align-items-center gap-2" style={{ fontSize }}>
            <select
              value={localPrimary || ""}
              onChange={handlePrimaryChange}
              className="form-select"
              style={{ fontSize }}
            >
              <option value="">Select Primary Status</option>
              {dropdownOptions.primary.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>

            <select
              value={localSecondary || ""}
              onChange={handleSecondaryChange}
              className="form-select"
              style={{ fontSize }}
              disabled={isSecondaryDisabled}
            >
              <option value="">Select Secondary Status</option>
              {secondaryOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>

            {isDirty && (
              <FaSave
                onClick={canSave ? handleSave : undefined}
                title={canSave ? "Save changes" : "Select secondary status to enable"}
                style={{
                  color: canSave ? "#ff9966" : "#ccc",
                  cursor: canSave ? "pointer" : "not-allowed",
                  fontSize: "32px",
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: "Assign",
      accessor: "id",
      Cell: ({ cell: { row } }) => {
        const assignedSalesId = row.original.assignedSalesId || "";
        const [selectedEmployee, setSelectedEmployee] = useState(assignedSalesId);
        const [showIcon, setShowIcon] = useState(false);

        useEffect(() => {
          setSelectedEmployee(row.original.assignedSalesId || "");
          setShowIcon(false);
        }, [row.original.assignedSalesId]);

        const handleChange = (e) => {
          const newValue = e.target.value;
          setSelectedEmployee(newValue);
          setShowIcon(newValue !== assignedSalesId);
        };

        const handleAssignClick = async () => {
          if (selectedEmployee) {
            if (selectedEmployee === "self") {
              await handleSelfAssign(row.original.leadid);
            } else {
              await handleAssignLead(row.original.leadid, selectedEmployee, row.original.status);
            }
            setShowIcon(false);
          } else {
            setMessage("Please select an employee to assign the lead.");
            setTimeout(() => setMessage(""), 1000);
          }
        };

        return (
          <div className="d-flex align-items-center" style={{ fontSize }}>
            <Form.Select
              value={selectedEmployee}
              onChange={handleChange}
              className="me-2"
              style={{ fontSize }}
            >
              <option value="self">Self</option>
              {employees.map((employee) => (
                <option key={employee.id} value={employee.id}>
                  {employee.name}
                </option>
              ))}
            </Form.Select>
            {showIcon && (
              <HiUserGroup
                style={{ color: "#ff9966", cursor: "pointer", fontSize: "20px" }}
                onClick={handleAssignClick}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        const currentPage = pageIndex;
              const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaEdit
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => handleEdit(row.original.leadid, currentPage,pageSize)}
            />
            <FaEye
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => navigate(`/m-mydetails/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}
            />
                    {/* <FaComment
                       style={{ color: "#ff9966", cursor: "pointer" }}
                       onClick={() => navigate(`/m-opportunity-comments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}
                     /> */}
                       <FaComment
                                                             style={{ color: "#ff9966", cursor: "pointer" }}
                                                             onClick={() => handleCommentClick(row.original,)}
                                                           />
            <FaRupeeSign
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => navigate(`/m-mypayments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}
            />
          </div>
        );
      },
    },
  ], [dropdownOptions, pageIndex, employees,location]);

  const uniqueDestinations = useMemo(() => {
    const normalizedDestinations = data
      .map(item => item.travel_destination?.trim())
      .filter(dest => dest)
      .map(dest => dest.toLowerCase());
    return [...new Set(normalizedDestinations)]
      .map(dest => dest.charAt(0).toUpperCase() + dest.slice(1));
  }, [data]);

  return (
    <div className="salesOpportunitycontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesOpportunity ${collapsed ? "collapsed" : ""}`}>
        <div className="potentialleads-table-container">
          <Row className="mb-3">
            <Col className="d-flex justify-content-between align-items-center fixed">
              <h3>Opportunity Details</h3>
              {message && <div className="alert alert-info">{message}</div>}
            </Col>
          </Row>
          <Row className="mb-3 align-items-center">
            <Col md={6} className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Free Text Search..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  localStorage.setItem("searchTerm-m", e.target.value);
                }}
              />
              {showDateRange ? (
                <FaTimes
                  onClick={() => {
                    setShowDateRange(false);
                    localStorage.setItem("showDateRange-m", "false");
                    setFilterStartDate("");
                    setFilterEndDate("");
                    setAppliedFilterStartDate("");
                    setAppliedFilterEndDate("");
                    localStorage.removeItem("filterStartDate-m");
                    localStorage.removeItem("filterEndDate-m");
                    localStorage.removeItem("appliedFilterStartDate-m");
                    localStorage.removeItem("appliedFilterEndDate-m");
                  }}
                  style={{ cursor: "pointer", fontSize: "1.5rem" }}
                  title="Hide Date Range"
                />
              ) : (
                <FaCalendarAlt
                  onClick={() => {
                    setShowDateRange(true);
                    localStorage.setItem("showDateRange-m", "true");
                  }}
                  style={{ cursor: "pointer", fontSize: "1.5rem" }}
                  title="Show Date Range"
                />
              )}
              {showDateRange && (
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="date"
                    className="form-control"
                    value={filterStartDate}
                    onChange={(e) => setFilterStartDate(e.target.value)}
                  />
                  <span>to</span>
                  <input
                    type="date"
                    className="form-control"
                    value={filterEndDate}
                    onChange={(e) => setFilterEndDate(e.target.value)}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setAppliedFilterStartDate(filterStartDate);
                      setAppliedFilterEndDate(filterEndDate);
                    }}
                  >
                    OK
                  </button>
                </div>
              )}
            </Col>
            <Col md={6} className="d-flex justify-content-end">
              <button className="btn btn-secondary" onClick={clearFilters}>
                Clear Filters
              </button>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <select
                className="form-select"
                value={filterDestination}
                onChange={(e) => setFilterDestination(e.target.value)}
              >
                <option value="">Destinations</option>
                {uniqueDestinations.map((dest) => (
                  <option key={dest} value={dest}>{dest}</option>
                ))}
              </select>
            </Col>
            <Col md={2}>
              <select
                className="form-select"
                value={filterOppStatus1}
                onChange={(e) => { setFilterOppStatus1(e.target.value); setFilterOppStatus2(""); }}
              >
                <option value="">Primary Status</option>
                {dropdownOptions.primary.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </Col>
            <Col md={3}>
              <select
                className="form-select"
                value={filterOppStatus2}
                onChange={(e) => setFilterOppStatus2(e.target.value)}
              >
                <option value="">Secondary Status</option>
                {dropdownOptions.secondary[filterOppStatus1]?.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </Col>
             <Col md={2}>
                          <select
                            className="form-select"
                            value={filterPrimarySource}
                            onChange={(e) => {
                              setFilterPrimarySource(e.target.value);
                              setFilterSecondarySource(""); // reset secondary
                              setPageIndex(0);
                        
                              const url = new URL(window.location);
                              url.searchParams.delete("page");
                              window.history.pushState({}, "", url);
                            }}
                          >
                            <option value="">Primary Source</option>
                           {primarySourceOptions.map((source) => (
                              <option key={source} value={source}>
                                {source}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col md={2}>
                          <select
                            className="form-select"
                            value={filterSecondarySource}
                            onChange={(e) => {
                              setFilterSecondarySource(e.target.value);
                              setPageIndex(0);
                        
                              const url = new URL(window.location);
                              url.searchParams.delete("page");
                              window.history.pushState({}, "", url);
                            }}
                            disabled={!filterPrimarySource}
                          >
                            <option value="">Secondary Source</option>
                            {sourceDropdownOptions[filterPrimarySource]?.map((source) => (
                              <option key={source} value={source}>
                                {source}
                              </option>
                            ))}
                          </select>
                        </Col>
          </Row>

          {/* Fixed loading/empty/data render */}
          {isLoading ? (
                                <Loader />
                              ) : data.length === 0 ? (
                                          <div className="text-center p-5">
                                            <p>No data available</p>
                                          </div>
                                        ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pageIndex={pageIndex}
              setPageIndex={setPageIndex}
            />
          )}
        </div>
      </div>
   <EmailCommentModalPop
  show={showCommentsEmailModal}
  onHide={() => {
    setShowCommentsEmailModal(false);
    setSelectedLeadForModal(null);
  }}
  selectedLead={selectedLeadForModal}
  baseURL={baseURL}
  userName={userName}
  userEmail={userEmail} // Make sure you have userEmail from AuthContext
/>
    </div>
  );
};

export default Potentialleads;